import React from "react";
import { cn } from "@/lib/utils";

export function PageHeader({ title, description, actions, meta, className }) {
  return (
    <div className={cn("flex flex-wrap items-end justify-between gap-3 mb-5", className)}>
      <div className="min-w-0">
        <h1 className="text-ptitle text-ink-primary">{title}</h1>
        {description && <p className="text-compact text-ink-secondary mt-1 max-w-2xl">{description}</p>}
        {meta && <div className="flex flex-wrap items-center gap-2 mt-2">{meta}</div>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2 justify-end max-w-full">{actions}</div>}
    </div>
  );
}
